import { UserPermission } from '@globaleris/ui.library'
import {
  Avatar,
  Card,
  CardContent,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  makeStyles,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ButtonWithPermissions from '../../../components/buttonWithPermissions/buttonWithPermissions'
import { hasPermission } from '../../../helpers/permissionsHelper'
import { NonAuthRoutes } from '../../../model'
import { Resources } from '../../../model/RBAC/constants'
import { styles } from '../clientes.styles'
import {
  AnnouncementItemType,
  AnnouncementItemTypes,
  LandingSujectKpisModel,
  SubjectAnnouncementModel
} from '../clients.model'
import { AnnouncementDialogTable } from './AnnouncementDialogTable'

export interface AnnouncementListItemProps {
  announcements: SubjectAnnouncementModel
  itemType: AnnouncementItemTypes
  subjectType: number
}

const AnnouncementListItem: React.FC<AnnouncementListItemProps> = ({
  announcements,
  itemType,
  subjectType
}) => {
  let history = useHistory()
  const [t] = useTranslation(['globalerisLibrary', 'clients', 'enums'])

  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  const mobile = useMediaQuery(currentTheme.breakpoints.down('xs'))
  const responsive = useMediaQuery(currentTheme.breakpoints.down('sm'))

  const [openAnnouncementsDialog, setOpenAnnouncementsDialog] = useState<boolean>(false)
  const [showFormDetail, setShowFormDetail] = useState<boolean>(false)

  const getListCountByType = (itemType: AnnouncementItemTypes) => {
    let result: number = 0
    switch (itemType) {
      case AnnouncementItemType.CONTRACTS_NEXT_EXPIRATION: {
        result = announcements.contractsSubjectNextExpiration.length
        break
      }
      case AnnouncementItemType.SUBJECT_WITHOUT_CONTRACTS: {
        result = announcements.activeSubjectWithoutContracts.length
        break
      }
      case AnnouncementItemType.PROCEDURES_IN_PROGRESS: {
        result = announcements.proceduresInProgress.length
        break
      }
      case AnnouncementItemType.INCIDENT_PROCEDURES: {
        result = announcements.incidentProcedures.length
        break
      }
    }
    return result
  }

  const getTableTitle = () => {
    return t(`clients:landingPage.announcement.${itemType}.title`)
  }

  const onViewMoreClickHandler = async (itemType: AnnouncementItemTypes) => {
    if (itemType) {
      // if(itemType == AnnouncementItemType.CONTRACTS_NEXT_EXPIRATION ||
      //   itemType == AnnouncementItemType.SUBJECT_WITHOUT_CONTRACTS) {
      //           setOpenAnnouncementsDialog(true);
      // } else {
      //   history.push(NonAuthRoutes.comunicationCenter);
      // }
      setOpenAnnouncementsDialog(true)
    }
  }

  const handleCloseAnnouncementsDialog = () => {
    setOpenAnnouncementsDialog(false)
  }

  return itemType == AnnouncementItemType.WITHOUT_ANNOUNCEMENT ? (
    <ListItem key={1}>
      <ListItemText
        secondary={t('clients:landingPage.announcement.withoutAnnouncement')}
        secondaryTypographyProps={{
          style: { wordWrap: 'break-word', textAlign: responsive ? 'center' : 'left' }
        }}
      />
    </ListItem>
  ) : (
    <ListItem key={itemType}>
      <Card key={itemType} style={{ width: '100%' }}>
        <CardContent
          className={classes.cardAnnouncement}
          style={{
            display: 'flex',
            flexDirection: responsive ? 'column' : 'row',
            justifyContent: responsive ? 'center' : 'space-between'
          }}
        >
          <ListItem>
            {!mobile ? (
              <ListItemAvatar>
                <Avatar>{t(`clients:landingPage.announcement.${itemType}.avatar`)}</Avatar>
              </ListItemAvatar>
            ) : null}

            <ListItemText
              primary={t(`clients:landingPage.announcement.${itemType}.primaryText`, {
                count: getListCountByType(itemType)
              })}
              secondary={t(`clients:landingPage.announcement.${itemType}.secondaryText`)}
              secondaryTypographyProps={{ style: { wordWrap: 'break-word' } }}
              style={{ justifyContent: responsive ? 'center' : 'flex-start' }}
            />
          </ListItem>
          <ListItem
            style={{
              alignItems: responsive ? 'center' : 'flex-end',
              justifyContent: responsive ? 'center' : 'flex-end'
            }}
          >
            {hasPermission(Resources.Client, [UserPermission.READ_ONLY, UserPermission.EDIT]) ? (
              <ButtonWithPermissions
                onClick={() => onViewMoreClickHandler(itemType)}
                size="small"
                color="primary"
                hasPermission={hasPermission(Resources.Client, [UserPermission.EDIT])}
                className={classes.actionAnnouncement}
              >
                {t('clients:landingPage.announcement.secondaryAction')}
              </ButtonWithPermissions>
            ) : null}
          </ListItem>
        </CardContent>
        {openAnnouncementsDialog && (
          <AnnouncementDialogTable
            announcements={announcements}
            itemType={itemType}
            tableTitle={getTableTitle()}
            subjectType={subjectType}
            onClose={handleCloseAnnouncementsDialog}
          />
        )}
      </Card>
    </ListItem>
  )
}

export default AnnouncementListItem
